import React from "react";
import Scrollbar from "react-scrollbars-custom";
import Markdown from "../../components/Markdown";

const CardNote = ({ note }) => (
  <div className="card__note">
    <Scrollbar style={{ height: "209px" }} data-simplebar-auto-hide="false">
      <Markdown text={note} className="card__note_body" />
    </Scrollbar>
  </div>
);

export default CardNote;
